"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var layoutBaseTheme = function (_a) {
    var _b, _c, _d;
    var MIN_L = _a.MIN_L, MEDIA_PRINT = _a.MEDIA_PRINT;
    return ({
        layout: {
            overflowY: "auto",
            "&.header-fixed": (_b = {
                    marginTop: "5rem",
                    height: "calc(100% - 5rem)"
                },
                _b[MEDIA_PRINT] = {
                    marginTop: "0",
                    height: "100%"
                },
                _b),
            "&.header-sticky": (_c = {
                    marginTop: "5rem",
                    height: "calc(100% - 5rem)"
                },
                _c[MEDIA_PRINT] = {
                    marginTop: "0",
                },
                _c),
            height: "100%",
            display: "flex",
            flexDirection: "column",
            width: "100%"
        },
        layoutContainer: {
            display: "flex",
            flexDirection: "column",
            flex: 1,
            order: 3,
            "&.header-sticky": {
                height: "100%"
            }
        },
        layoutLogout: {},
        layoutLogoutLink: {
            display: "flex",
            flexDirection: "row-reverse",
            alignItems: "center",
        },
        layoutLogoutLinkIcon: {
            fontSize: "inherit",
            marginLeft: "0.5rem",
            verticalAlign: "middle",
            alignSelf: "center",
            name: "logout"
        },
        layoutLoginButton: {
            display: "flex",
            flexDirection: "row-reverse"
        },
        layoutLoginButtonIcon: {
            name_logged_in: "account_circle",
            name: "login",
            verticalAlign: "middle",
            marginLeft: "0.5rem"
        },
        layoutLoginPopover: {},
        layoutHeaderTitle: (_d = {
                display: "none"
            },
            _d[MIN_L] = {
                flex: 1,
                whiteSpace: "nowrap",
                display: "flex",
                marginLeft: "2rem",
                fontSize: "1.5rem",
            },
            _d),
        layoutHeaderLinks: {
            justifyContent: "flex-end",
            display: "flex"
        },
        layoutHeaderLinksItem: {
            textDecoration: "none",
            "&:hover, &:active": {
                textDecoration: "none"
            }
        }
    });
};
exports.default = layoutBaseTheme;
//# sourceMappingURL=layout.js.map